import { tc2 } from "./T&C2";
export default `
<html><head>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8">
<meta name="Generator" content="Microsoft Word 15 (filtered)">
<title>1. HSBCPB Asia - Internet Banking Terms v6 - (Clean)(3 Oct 23) - HSF
draft 1 - 13.12.2023</title>

<style id="dynCom" type="text/css"><!-- --></style>
<script language="JavaScript"><!--
function msoCommentShow(anchor_id, com_id)
{
	if(msoBrowserCheck()) 
		{
		c = document.all(com_id);
		a = document.all(anchor_id);
		if (null != c && null == c.length && null != a && null == a.length)
			{
			var cw = c.offsetWidth;
			var ch = c.offsetHeight;
			var aw = a.offsetWidth;
			var ah = a.offsetHeight;
			var x  = a.offsetLeft;
			var y  = a.offsetTop;
			var el = a;
			while (el.tagName != "BODY") 
				{
				el = el.offsetParent;
				x = x + el.offsetLeft;
				y = y + el.offsetTop;
				}
			var bw = document.body.clientWidth;
			var bh = document.body.clientHeight;
			var bsl = document.body.scrollLeft;
			var bst = document.body.scrollTop;
			if (x + cw + ah / 2 > bw + bsl && x + aw - ah / 2 - cw >= bsl ) 
				{ c.style.left = x + aw - ah / 2 - cw; }
			else 
				{ c.style.left = x + ah / 2; }
			if (y + ch + ah / 2 > bh + bst && y + ah / 2 - ch >= bst ) 
				{ c.style.top = y + ah / 2 - ch; }
			else 
				{ c.style.top = y + ah / 2; }
			c.style.visibility = "visible";
}	}	}
function msoCommentHide(com_id) 
{
	if(msoBrowserCheck())
		{
		c = document.all(com_id);
		if (null != c && null == c.length)
		{
		c.style.visibility = "hidden";
		c.style.left = -1000;
		c.style.top = -1000;
		} } 
}
function msoBrowserCheck()
{
	ms = navigator.appVersion.indexOf("MSIE");
	vers = navigator.appVersion.substring(ms + 5, ms + 6);
	ie4 = (ms > 0) && (parseInt(vers) >= 4);
	return ie4;
}
if (msoBrowserCheck())
{
	document.styleSheets.dynCom.addRule(".msocomanchor","background: infobackground");
	document.styleSheets.dynCom.addRule(".msocomoff","display: none");
	document.styleSheets.dynCom.addRule(".msocomtxt","visibility: hidden");
	document.styleSheets.dynCom.addRule(".msocomtxt","position: absolute");
	document.styleSheets.dynCom.addRule(".msocomtxt","top: -1000");
	document.styleSheets.dynCom.addRule(".msocomtxt","left: -1000");
	document.styleSheets.dynCom.addRule(".msocomtxt","width: 33%");
	document.styleSheets.dynCom.addRule(".msocomtxt","background: infobackground");
	document.styleSheets.dynCom.addRule(".msocomtxt","color: infotext");
	document.styleSheets.dynCom.addRule(".msocomtxt","border-top: 1pt solid threedlightshadow");
	document.styleSheets.dynCom.addRule(".msocomtxt","border-right: 2pt solid threedshadow");
	document.styleSheets.dynCom.addRule(".msocomtxt","border-bottom: 2pt solid threedshadow");
	document.styleSheets.dynCom.addRule(".msocomtxt","border-left: 1pt solid threedlightshadow");
	document.styleSheets.dynCom.addRule(".msocomtxt","padding: 3pt 3pt 3pt 3pt");
	document.styleSheets.dynCom.addRule(".msocomtxt","z-index: 100");
}
// --></script>
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:Wingdings;
	panose-1:5 0 0 0 0 0 0 0 0 0;}
@font-face
	{font-family:SimSun;
	panose-1:2 1 6 0 3 1 1 1 1 1;}
@font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
	{font-family:Calibri;
	panose-1:2 15 5 2 2 2 4 3 2 4;}
@font-face
	{font-family:"Segoe UI";
	panose-1:2 11 6 4 2 2 2 2 2 4;}
@font-face
	{font-family:"\@SimSun";
	panose-1:2 1 6 0 3 1 1 1 1 1;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;}
h1
	{mso-style-link:"Heading 1 Char";
	margin-top:12.0pt;
	margin-right:0cm;
	margin-bottom:0cm;
	margin-left:0cm;
	page-break-after:avoid;
	font-size:16.0pt;
	font-family:"Calibri Light",sans-serif;
	color:#2E74B5;
	font-weight:normal;}
p.MsoCommentText, li.MsoCommentText, div.MsoCommentText
	{mso-style-link:"Comment Text Char";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;}
p.MsoHeader, li.MsoHeader, div.MsoHeader
	{mso-style-link:"Header Char";
	margin:0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;}
p.MsoFooter, li.MsoFooter, div.MsoFooter
	{mso-style-link:"Footer Char";
	margin:0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;}
a:link, span.MsoHyperlink
	{color:#0563C1;
	text-decoration:underline;}
a:visited, span.MsoHyperlinkFollowed
	{color:#954F72;
	text-decoration:underline;}
p.MsoCommentSubject, li.MsoCommentSubject, div.MsoCommentSubject
	{mso-style-link:"Comment Subject Char";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	font-weight:bold;}
p.MsoAcetate, li.MsoAcetate, div.MsoAcetate
	{mso-style-link:"Balloon Text Char";
	margin:0cm;
	font-size:9.0pt;
	font-family:"Segoe UI",sans-serif;}
span.MsoPlaceholderText
	{color:gray;}
p.MsoRMPane, li.MsoRMPane, div.MsoRMPane
	{margin:0cm;
	font-size:11.0pt;
	font-family:"Calibri",sans-serif;}
p.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph
	{margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:36.0pt;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;}
p.MsoListParagraphCxSpFirst, li.MsoListParagraphCxSpFirst, div.MsoListParagraphCxSpFirst
	{margin-top:0cm;
	margin-right:0cm;
	margin-bottom:0cm;
	margin-left:36.0pt;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;}
p.MsoListParagraphCxSpMiddle, li.MsoListParagraphCxSpMiddle, div.MsoListParagraphCxSpMiddle
	{margin-top:0cm;
	margin-right:0cm;
	margin-bottom:0cm;
	margin-left:36.0pt;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;}
p.MsoListParagraphCxSpLast, li.MsoListParagraphCxSpLast, div.MsoListParagraphCxSpLast
	{margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:36.0pt;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;}
span.CommentTextChar
	{mso-style-name:"Comment Text Char";
	mso-style-link:"Comment Text";}
span.CommentSubjectChar
	{mso-style-name:"Comment Subject Char";
	mso-style-link:"Comment Subject";
	font-weight:bold;}
span.BalloonTextChar
	{mso-style-name:"Balloon Text Char";
	mso-style-link:"Balloon Text";
	font-family:"Segoe UI",sans-serif;}
p.parapadding, li.parapadding, div.parapadding
	{mso-style-name:parapadding;
	margin-right:0cm;
	margin-left:0cm;
	font-size:12.0pt;
	font-family:SimSun;}
span.HeaderChar
	{mso-style-name:"Header Char";
	mso-style-link:Header;}
span.FooterChar
	{mso-style-name:"Footer Char";
	mso-style-link:Footer;}
span.Heading1Char
	{mso-style-name:"Heading 1 Char";
	mso-style-link:"Heading 1";
	font-family:"Calibri Light",sans-serif;
	color:#2E74B5;}
p.Default, li.Default, div.Default
	{mso-style-name:Default;
	margin:0cm;
	text-autospace:none;
	font-size:12.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.DocsID, li.DocsID, div.DocsID
	{mso-style-name:DocsID;
	mso-style-link:"DocsID Char";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:0cm;
	font-size:8.0pt;
	font-family:"Arial",sans-serif;}
span.DocsIDChar
	{mso-style-name:"DocsID Char";
	mso-style-link:DocsID;}
p.StandardL1, li.StandardL1, div.StandardL1
	{mso-style-name:Standard_L1;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:1.0cm;
	text-align:justify;
	text-indent:-22.6pt;
	page-break-after:avoid;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;
	font-weight:bold;}
p.StandardL2, li.StandardL2, div.StandardL2
	{mso-style-name:Standard_L2;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:1.0cm;
	text-indent:-22.6pt;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardL3, li.StandardL3, div.StandardL3
	{mso-style-name:Standard_L3;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:2.0cm;
	text-indent:-28.9pt;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardL4, li.StandardL4, div.StandardL4
	{mso-style-name:Standard_L4;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:3.0cm;
	text-indent:-1.0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardL5, li.StandardL5, div.StandardL5
	{mso-style-name:Standard_L5;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:4.0cm;
	text-indent:-1.0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardL6, li.StandardL6, div.StandardL6
	{mso-style-name:Standard_L6;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:5.0cm;
	text-indent:-1.0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardL7, li.StandardL7, div.StandardL7
	{mso-style-name:Standard_L7;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:6.0cm;
	text-indent:-1.0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardL8, li.StandardL8, div.StandardL8
	{mso-style-name:Standard_L8;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:7.0cm;
	text-align:justify;
	text-indent:-1.0cm;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardL9, li.StandardL9, div.StandardL9
	{mso-style-name:Standard_L9;
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:226.75pt;
	text-align:justify;
	text-indent:-28.3pt;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardNoL1, li.StandardNoL1, div.StandardNoL1
	{mso-style-name:"Standard_No\#L1";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:1.0cm;
	text-align:justify;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardNoL2, li.StandardNoL2, div.StandardNoL2
	{mso-style-name:"Standard_No\#L2";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:1.0cm;
	text-align:justify;
	line-height:150%;
	page-break-after:avoid;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;
	font-weight:bold;}
p.StandardNoL3, li.StandardNoL3, div.StandardNoL3
	{mso-style-name:"Standard_No\#L3";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:2.0cm;
	text-align:justify;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardNoL4, li.StandardNoL4, div.StandardNoL4
	{mso-style-name:"Standard_No\#L4";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:3.0cm;
	text-align:justify;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardNoL5, li.StandardNoL5, div.StandardNoL5
	{mso-style-name:"Standard_No\#L5";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:4.0cm;
	text-align:justify;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardNoL6, li.StandardNoL6, div.StandardNoL6
	{mso-style-name:"Standard_No\#L6";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:5.0cm;
	text-align:justify;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardNoL7, li.StandardNoL7, div.StandardNoL7
	{mso-style-name:"Standard_No\#L7";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:6.0cm;
	text-align:justify;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardNoL8, li.StandardNoL8, div.StandardNoL8
	{mso-style-name:"Standard_No\#L8";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:7.0cm;
	text-align:justify;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardNoL9, li.StandardNoL9, div.StandardNoL9
	{mso-style-name:"Standard_No\#L9";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:12.0pt;
	margin-left:226.75pt;
	text-align:justify;
	font-size:10.0pt;
	font-family:"Arial",sans-serif;
	color:black;}
p.StandardHeading, li.StandardHeading, div.StandardHeading
	{mso-style-name:"Standard Heading";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:18.0pt;
	margin-left:35.7pt;
	text-align:center;
	text-indent:-17.85pt;
	font-size:12.0pt;
	font-family:"Arial",sans-serif;
	font-weight:bold;}
p.StandardHeadingCxSpFirst, li.StandardHeadingCxSpFirst, div.StandardHeadingCxSpFirst
	{mso-style-name:"Standard HeadingCxSpFirst";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:0cm;
	margin-left:35.7pt;
	text-align:center;
	text-indent:-17.85pt;
	font-size:12.0pt;
	font-family:"Arial",sans-serif;
	font-weight:bold;}
p.StandardHeadingCxSpMiddle, li.StandardHeadingCxSpMiddle, div.StandardHeadingCxSpMiddle
	{mso-style-name:"Standard HeadingCxSpMiddle";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:0cm;
	margin-left:35.7pt;
	text-align:center;
	text-indent:-17.85pt;
	font-size:12.0pt;
	font-family:"Arial",sans-serif;
	font-weight:bold;}
p.StandardHeadingCxSpLast, li.StandardHeadingCxSpLast, div.StandardHeadingCxSpLast
	{mso-style-name:"Standard HeadingCxSpLast";
	margin-top:0cm;
	margin-right:0cm;
	margin-bottom:18.0pt;
	margin-left:35.7pt;
	text-align:center;
	text-indent:-17.85pt;
	font-size:12.0pt;
	font-family:"Arial",sans-serif;
	font-weight:bold;}
.MsoChpDefault
	{font-size:11.0pt;
	font-family:"Calibri",sans-serif;}
.MsoPapDefault
	{margin-bottom:8.0pt;
	line-height:107%;}
 /* Page Definitions */
 @page WordSection1
	{size:612.0pt 792.0pt;
	margin:54.0pt 72.0pt 72.0pt 72.0pt;}
div.WordSection1
	{page:WordSection1;}
@page WordSection2
	{size:612.0pt 792.0pt;
	margin:54.0pt 72.0pt 72.0pt 72.0pt;}
div.WordSection2
	{page:WordSection2;}
@page WordSection3
	{size:612.0pt 792.0pt;
	margin:54.0pt 72.0pt 72.0pt 72.0pt;}
div.WordSection3
	{page:WordSection3;}
@page WordSection4
	{size:612.0pt 792.0pt;
	margin:54.0pt 72.0pt 72.0pt 72.0pt;}
div.WordSection4
	{page:WordSection4;}
@page WordSection5
	{size:612.0pt 792.0pt;
	margin:54.0pt 72.0pt 72.0pt 72.0pt;}
div.WordSection5
	{page:WordSection5;}
 /* List Definitions */
 ol
	{margin-bottom:0cm;}
ul
	{margin-bottom:0cm;}
-->
</style>

</head>

<body lang="en-CN" link="#0563C1" vlink="#954F72" style="word-wrap:break-word">

<div class="WordSection1">


<p class="MsoNormal" align="right" style="text-align:right"><span lang="EN-US">&nbsp;</span></p>

<p class="MsoNormal"><span lang="EN-US">The terms of the services available on our
Internet Banking platform are set out below. Please read them carefully before
you proceed to the next page: </span></p>

<p class="MsoListParagraph" style="margin-left:35.7pt;text-indent:-17.85pt"><span lang="EN-US"><b>A.</b><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
</span></span><b><span lang="EN-US">Terms and Conditions for Internet Banking
Services</span></b><span lang="EN-US">, which sets out terms and conditions for
your access and use of the HSBC Private Bank internet banking platform;
</span></p>

<p class="MsoListParagraph" style="margin-left:35.7pt;text-indent:-17.85pt"><span lang="EN-US"><b>B.</b><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
</span></span><b><span lang="EN-US">Terms and Conditions for HSBC Private Bank
Insights &amp; Research</span></b><span lang="EN-US">, which sets out additional terms
and conditions for HSBC Private Bank Insights &amp; Research which you may
access and use through the HSBC Private Bank internet banking
platform; </span></p>

<p class="MsoListParagraph" style="margin-left:35.7pt;text-indent:-17.85pt"><b><span lang="EN-US">C.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; 
</span></span></b><b><span lang="EN-US">Terms and Conditions for Push Notification Service</span></b><span lang="EN-US">, which sets out additional terms and conditions for our provision
of Push Notification Services to you in respect of products and services you
can access or use through the HSBC Private Bank internet banking
platform; and</span></p>

<p class="MsoListParagraph" style="margin-left:35.7pt;text-indent:-17.85pt"><b><span lang="EN-US">D.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp; 
</span></span></b><b><span lang="EN-US">Terms and Conditions for eSignature </span></b><span lang="EN-US">Service,
which sets out additional terms and conditions application to any document
executed using eSignature.</span></p>

<p class="MsoListParagraph" style="margin-left:35.7pt;text-indent:-17.85pt"><b><span lang="EN-US">E.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang="EN-US">Terms and Conditions for the Suspicious
Proxy Alert Model</span></b><span lang="EN-US"> which relates to alerts for
potentially suspicious money transfers. &nbsp;</span></p>

<p class="MsoListParagraph" style="margin-left:35.7pt;text-indent:-17.85pt"><b><span lang="EN-US">F.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></b><b><span lang="EN-US">Terms and Conditions for the Global Transfers within HSBC Accounts</span></b><span lang="EN-US">, 
which sets out additional terms and conditions applying to transfers from an HSBC Private Bank account to any other self-named global HSBC account worldwide.&nbsp;</span></p>


</div>

<span lang="EN-US" style="font-size:10.0pt;font-family:&quot;Arial&quot;,sans-serif;
color:black"><br clear="all" style="page-break-before:always">
</span>

<div class="WordSection2">

<p class="MsoNormal"><span lang="EN-US">&nbsp;</span></p>

<p class="StandardHeading"><a name="_Ref122030146"><span lang="EN-US">A.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp; </span></span>
<span lang="EN-US">Terms and Conditions for Internet Banking Services</span></a></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref122097477"><span lang="EN-US"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;</span>
1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Definitions and Interpretation</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm;"><span lang="EN-US">1.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Unless otherwise defined here, expressions
defined in our Standard Terms and Conditions (as found <a href="https://www.privatebanking.hsbc.com/content/dam/privatebanking/gpb/utilities/mobile/standard-terms-and-conditions-en.pdf">here</a>,
the “<b>Standard Terms</b>”) as may be amended from time to time shall have the
same meaning when used in these Terms and Conditions for Internet Banking
Services (the “<b>Internet Banking Terms</b>”). If there are any
inconsistencies between these Internet Banking Terms and the Standard Terms,
these Internet Banking Terms shall prevail.&nbsp; </span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">1.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">In these Internet Banking Terms, the following
capitalised terms shall have the following meanings unless the context requires
otherwise:</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Authorized</b>
<b>Internet</b> <b>User</b>” means such person(s) designated by (and may
include) you with authority to use the Internet Banking Services in respect of
your Account(s). </span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Digital Lockdown</b>”
means the security feature on the Internet Site which suspends all access to Internet Banking Services upon activation. </span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Information</b>”
means financial, market or other information and data made available by us via
any Internet Site, supplied by any Information Provider, including any such
information contained in “Publications” as defined in Part B.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Information
Provider</b>” means any person or entity, including us and any Group Office who
supplies Information and any other person or entity who supplies any
information to an Information Provider.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Internet Site</b>”
means any Internet site or other platform established, operated and/or
maintained by or on behalf of us for the provision of the Internet Banking
Services and includes the Mobile Banking Application.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Internet
Banking Services</b>” means the services described in Clause </span><span lang="EN-US">2</span><span lang="EN-US"> <i>(Internet Banking Services</i>) below,
as may be amended from time to time and includes the I&amp;R Services provided
under Part B, Mobile Banking Application Services and eSignature provided under
Part D.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Internet
Banking Terms</b>” means these Terms and Conditions for Internet Banking
Services.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<a name="_Hlk162520573"><b>Mobile Banking</b> <b>Application</b></a>” means the
application made available by us and downloaded to your mobile device through
which the Mobile Banking Application Services may be accessed.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Mobile Banking
Application Services</b>” means services made available to you to enable you to
access Internet Banking Services using the Mobile Banking Application,
including the Push Notification Service as defined in Part C.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Password</b>”
means the password used by the Authorized Internet User for the purposes of
accessing the Internet Banking Services.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Reports</b>”
means any reports compiled from Information in any form, medium or means,
including any “Publications” as defined in Part B.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Security Code</b>”
means any code provided by us and used for the purposes of accessing the
Internet Banking Services.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Standard Terms</b>”
has the meaning ascribed to it in Clause </span><span lang="EN-US">1</span><span lang="EN-US"> (<i>Definitions and Interpretation</i>) of
these Internet Banking Terms.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>Us</b>”, “<b>our</b>”,
“<b>we</b>” or words to that or a similar effect means the Bank.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>User ID</b>”
means the Authorized Internet User’s user identification code accepted by us
for the purposes of accessing the Internet Banking Services.</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">“<b>You</b>”, “<b>your</b>”
or words to that or a similar effect means the Customer and, where the context
permits, includes any person authorized by the Customer to give instructions or
requests to us in connection with the use of the Internet Banking Services,
including any Authorized Internet User.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref121937267"><span lang="EN-US"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;</span>2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Internet Banking Services</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref122018218"><span lang="EN-US">2.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">We may make available through any Internet Site
online services from time to time to enable you to give Communication to us for
the purposes of operating the Customer Account(s), conducting banking,
investment, financial and other transactions and dealings of various nature and
obtaining services, products, Information, Reports, benefits and privileges
from us as shall be made available from time to time.</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">2.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">We have the right to determine and vary from
time to time the scope and type of the Internet Banking Services to be made
available including, without limitation:</span></p>

<p class="StandardL3"><span lang="EN-US">(A)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">expanding, modifying or reducing the Internet
Banking Services at any time;</span></p>

<p class="StandardL3"><span lang="EN-US">(B)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">imposing and varying any restrictions on the use
of the Internet Banking Services (or any part thereof) such as minimum and
maximum daily limits with respect to the value of any transaction or dealing or
type of transactions or dealings which you may conduct by using the Internet
Banking Services; and</span></p>

<p class="StandardL3"><span lang="EN-US">(C)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">prescribing and changing the normal service
hours during which the Internet Banking Services (or any part thereof) are
available and any daily cut-off time for any type of Internet Banking Services,
transactions or dealings. Any instruction of yours received after any
applicable daily cut off time shall be deemed to be received on the next
Business Day. We may specify Business Days and daily cut-off times by reference
to the time of various markets operating in different time zones.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">2.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">We may, in our discretion, suspend or terminate
the Internet Banking Services generally or in relation to any Customer Account
or group of Customer Accounts provided that in any such instance, we shall provide
you with as much notice as possible if you are affected provided that in
circumstances where it is reasonably necessary to protect our legitimate
interests or where required by any Laws or in relation to Financial Crime
Management Activity (including but not limited to fraud prevention) when
suspension or termination may be made without prior notice. In the event your
access to the Internet Banking Services is suspended, restricted or terminated,
we may close any accounts, products or services that are only available through
the Internet Banking Services, you will no longer receive digital statements,
and you should delete our Mobile Banking Application from your device (if
applicable).</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">2.4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">We may require you to nominate or register
specific Customer Account(s) for the purposes of the Internet Banking Services.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">2.5<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You may terminate the use of the Internet
Banking Services and/or the authority of any Authorized Internet User at any
time by giving to us prior written notice.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">2.6<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">All provisions of these Internet Banking Terms
which in order to give effect to their meaning need to survive the suspension
or termination of the Internet Banking Services and/or your use of the Internet
Banking Services shall remain in full force and effect after suspension or
termination including, without limitation, Clauses </span><span lang="EN-US">4</span><span lang="EN-US"> (<i>General Disclaimers</i>), </span><span lang="EN-US">7</span><span lang="EN-US"> (<i>User ID and Password &amp; Security</i>),
</span><span lang="EN-US">9</span><span lang="EN-US"> (<i>Information and
Information Providers</i>), </span><span lang="EN-US">11</span><span lang="EN-US"> (<i>Liabilities
of the Bank</i>) and </span><span lang="EN-US">12</span><span lang="EN-US"> (<i>Liabilities
of the Customer</i>). Notwithstanding such suspension or termination, you shall
continue to be bound by these Internet Banking Terms to the extent that they
relate to any of your obligations or liabilities which remain to be performed
or discharged.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref122022274"><span lang="EN-US"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;</span>3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Governing Terms</span></a></p>

<p class="StandardL2" style="text-indent:0cm"><a name="_Ref122018270"><span lang="EN-US">Any transactions and dealings effected by using the Internet Banking
Services are subject to these Internet Banking Terms, the Standard Terms and
all other Account Documentation governing the relevant Customer Account(s),
transactions, dealings, services, products, Information, Reports, benefits or
privileges.</span></a></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref122023934"><span lang="EN-US"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;</span>4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">General Disclaimers</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Hlk137649307"></a><a name="_Ref137718500"><span lang="EN-US">4.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">All transactions that you may enter into through
the Internet Banking Services (as made available from time to time) are
conducted on an execution-only basis and based on your own judgment. We do not
have any duty to assess or ensure suitability of the products or the
transactions that you enter into through the Internet Banking Services. This
clause </span></a><span lang="EN-US">4.1</span><span lang="EN-US"> shall not apply
where expressly excluded by the Bank in writing.</span><span lang="EN-US"> </span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">4.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">A solicitation or recommendation we may have
made to or for you for which applicable Laws require a suitability assessment
be made is valid only as at the time it was made, and we cannot ensure on-going
suitability of such product. By executing a transaction for a product through
use of Internet Banking Services, you understand and accept that if the
circumstances relating to you, such a product or its issuer or market
conditions change, the product may no longer be suitable for you and you trade
using the Internet Banking Services at your own risk.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">4.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You are responsible for determining
independently market prices and rates for trading purposes through your usual
trading channels, verifying any Information and/or Report before relying or
acting on it and seeking independent professional advice on legal, tax and
other issues in connection with the use of the Internet Banking Services, the
Information and the Reports and any transactions and dealings which may affect
you under all applicable Laws. </span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">4.4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Any exchange rate, interest rate, dealing rate
and other prices and Information quoted by us on the Internet Site(s) or
otherwise in response to an online inquiry is for reference only and is not
binding. Any rate, price and Information offered by us for the purpose of the
relevant transaction shall be binding on you upon you confirming acceptance,
irrespective of any different rate, price or Information quoted by us.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref122085592"><span lang="EN-US">4.5<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You understand that</span></a><span lang="EN-US" style="color:windowtext"> </span><span lang="EN-US">there are risks associated
with the use of services through the internet or through email, including but
not limited to unauthorized access, system outages, delays and disruption in
telecommunications services and the internet. Response times for Internet
Banking Services may vary due to market conditions, system performance, access
device location or other factors, and that access to Information may be limited
or unavailable during periods of peak demand, market volatility, system
upgrades, maintenance, or for any other reason. You acknowledge that
interruption or malfunction of communications, failure of software equipment,
malfunction of the your or our computer system for any reason, or failure to
keep your device browser or operating system or the Mobile Banking Application
up to date may prevent or restrict your ability to access the Internet Banking
Services, and that we will have no liability in respect of any such
interruption or malfunction <a name="_Hlk164182701">where the interruption or
malfunction is beyond our reasonable control</a>.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">4.6<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">The Internet Banking Services are only available
in selected jurisdictions. Information which is accessible using the Internet
Banking Services is not intended for distribution to, or use by, any person in
any jurisdiction where such distribution would be contrary to any law or
regulation of that jurisdiction. We do not guarantee that the Internet Banking
Services or the Information therein complies with the Laws of, or are
appropriate for use in, other jurisdictions.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">4.7<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You acknowledge that any products or services
you may view on or through the Internet Banking Services may not be registered
or authorized by any central bank, governmental or regulatory authority outside
of any jurisdiction where we are licensed or authorized to provide such
products or services or in your place of residence or location. Accordingly,
you may not be protected by the securities laws, banking laws, insurance laws
or other relevant Laws of any jurisdiction outside of where we are licensed or authorized
to provide such products or services or your place of residence with respect to
products or services you may view on or through Internet Banking Services.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">4.8<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">If you access and/or download our Mobile Banking
Application through a mobile application store, you acknowledge that: </span></p>

<p class="StandardL3"><span lang="EN-US">(A)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">we are responsible for the performance of our
Mobile Banking Application and that you should contact us regarding any
maintenance and support issues, content issues, malfunctions or other claims
related to our Mobile Banking Application; and</span></p>

<p class="StandardL3"><span lang="EN-US">(B)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">when you use our Mobile Banking Application,
such mobile application stores are considered as third party beneficiaries for
the purposes of these Internet Banking Terms and they may rely on these
Internet Banking Terms.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref122022289"><span lang="EN-US"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;</span>5<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Authorized Internet Users</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">5.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You shall:</span></p>

<p class="StandardL3"><span lang="EN-US">(A)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">designate the persons authorized by you to use
the Internet Banking Services in respect of the Customer Account(s) and the
scope of the authority of each such person in such manner and form as we may
prescribe from time to time; </span></p>

<p class="StandardL3"><span lang="EN-US">(B)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">advise us of any change in the mailing address
and/or email address of the Authorized Internet User(s); and</span></p>

<p class="StandardL3"><span lang="EN-US">(C)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">ensure that all Authorized Internet Users comply
with these Internet Banking Terms and the Standard Terms.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">5.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You and each Authorized Internet User shall
provide such information as we may from time to time reasonably request for the
provision of the Internet Banking Services.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">5.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You are responsible for the use of the Internet
Banking Services, for taking appropriate measures to monitor and control the
use of the Internet Banking Services and the appointment and change of the
Authorized Internet Users, and to adopt proper safeguards against the Internet
Banking Services being used by unauthorized persons or for unauthorized
purposes, including but not limited to those measures set out in Clause </span><span lang="EN-US">7</span><span lang="EN-US"> (<i>User ID and Password</i>) of these Internet
Banking Terms.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">5.4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Where you have appointed an Authorized Internet User
to use any Internet Banking Service, such Authorized Internet User accepts and
agrees to these Internet Banking Terms for and on your behalf, and you agree to
be bound by such acceptance and/or agreement by the Authorized Internet User. </span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref122022305"><span lang="EN-US"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;</span>6<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Use of the Internet Banking Services</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">6.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">The Internet Banking Services are for the sole
and exclusive use of Customers subscribing for the Internet Banking Services.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">6.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You shall neither do nor attempt to do any of
the following: </span></p>

<p class="StandardL3"><span lang="EN-US">(A)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">decompile, reverse engineer, translate, convert,
adapt, alter, modify, enhance, add to, delete or in any way tamper with, or
gain access to, any part of the Internet Banking Services or any Internet Site
or any software comprised in them;</span></p>

<p class="StandardL3"><span lang="EN-US">(B)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">use or knowingly allow any other person to use
the Internet Banking Services, the Information and/or the Reports for or in
connection with any illegal purpose or activity;</span></p>

<p class="StandardL3"><span lang="EN-US">(C)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">remove or attempt to remove any titles or
trademarks, copyrights or restricted rights notices in the Internet Banking
Services;</span></p>

<p class="StandardL3"><span lang="EN-US">(D)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">use any automated tools (i.e. bots) to access
the Internet Banking Services or perform activities; and/or</span></p>

<p class="StandardL3"><span lang="EN-US">(E)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">permit the use of any security testing tools in
order to provide, scan, or attempt to penetrate or assess the security of the
Internet Banking Services, </span></p>

<p class="StandardL3" style="margin-left:1.0cm;text-indent:0cm"><span lang="EN-US">and
shall notify us as soon as is practicable if you become aware of any such activity.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref122022738"><span lang="EN-US">6.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You must not upload or distribute files that
contain viruses or other malicious code to the Internet Banking Services or do
anything else to disrupt or attempt to disrupt, the systems and networks used
for the provision of the Internet Banking Services.</span></a><span lang="EN-US">
On becoming aware of an actual or suspected introduction of a virus or other
malicious code to the Internet Banking Services you must notify us promptly and
cooperate with us in mitigating the effects of such virus or malicious code.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">6.4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You acknowledge that there may be a time lag in
transmission of Information or Communication via the Internet.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref122080207"><span lang="EN-US">6.5<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You acknowledge that:</span></a></p>

<p class="StandardL3"><span lang="EN-US">(A)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">any information provided by you in connection
with your use of the Internet Banking Services may be disclosed to or made
accessible within our business, any Group Office, and/or our authorized service
providers who may be located in another jurisdiction; and</span></p>

<p class="StandardL3"><span lang="EN-US">(B)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">your use of the Internet Banking Services may be
monitored by us, any Group Office and/or our authorized service providers and
that any resulting information may be collected and used by us for our internal
business considerations or for any applicable Law,</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">all in accordance
with the terms of the Standard Terms and Conditions and you consent to such
disclosure, monitoring and/or use.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref121937280"><span lang="EN-US"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;</span>7<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">User ID and Password &amp; Security</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref156464096"><span lang="EN-US">7.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Each Authorized Internet User shall comply with
such procedures for designating his/her User ID and Password as we may
prescribe from time to time.</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">7.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Each Authorized Internet User may change the
User ID and Password at any time but any change shall be effective only if
accepted by us.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref122019050"><span lang="EN-US">7.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">We may, in our sole discretion, require you to
use a Security Code to access the Internet Banking Services.</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">7.4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Each Authorized Internet User shall act in good
faith, exercise reasonable care and diligence and take all reasonable
precautions in keeping safe and prevent fraudulent use of the User ID, the
Password and the Security Code. At no time and under no circumstances shall any
Authorized Internet User disclose the User ID, the Password and/or the Security
Code to any other person.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref122094900"><span lang="EN-US">7.5<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You are fully responsible for any accidental or
unauthorized disclosure of the User ID, the Password and/or the Security Code
of any Authorized Internet User to any other person and shall bear the risks of
the User ID, the Password, the Security Code or mobile device of any Authorized
Internet User being used by unauthorized persons or for unauthorized purposes.</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">7.6<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">If you activate the feature that allows you to
use your biometric credentials (such as fingerprint identity or face
recognition) in the Mobile Banking Application and enables the use of such
biometric credentials to log on to the Mobile Banking Application (or any other
Internet Banking Services that we may support from time to time (for compatible
devices only)), you must ensure that only your own biometric credentials are
registered on the device. You acknowledge and agree that: </span></p>

<p class="StandardL3"><span lang="EN-US">(A)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">we have no control over the technology,
availability, capability, verification method, security and integrity of the
mobile device and cannot be held responsible for any unauthorized access to the
Internet Banking Services using biometric credentials; and</span></p>

<p class="StandardL3"><span lang="EN-US">(B)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">you must not take any action to disable any
function provided by, or agree to any settings of, your device that would
otherwise compromise the security of the use of your biometric credentials for
authentication purposes (e.g. disabling “attention-aware” for facial
recognition)</span><span lang="EN-US">. </span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">7.7<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Upon notice or suspicion of an Authorized Internet User’s User ID, the Password and/or the Security Code 
being disclosed to any unauthorized person or any unauthorized use of the Internet Banking Services being made, you or the relevant 
Authorized Internet User shall notify us in person as soon as practicable or by telephone at such telephone number(s) as we may from 
time to time prescribe. We may ask you or the relevant Authorized Internet User to confirm in writing any details given. Until our 
actual receipt of such notification, you shall remain responsible for any and all use of the Internet Banking Services by unauthorized 
persons or for unauthorized purposes. You or the relevant Authorized Internet User shall also activate Digital Lockdown to suspend all 
access to Internet Banking Services.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><span lang="EN-US"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;</span>8<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Customer’s instructions</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">8.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Each Authorized Internet User shall enter
his/her User ID, Password, the Security Code and any other identifiers as shall
be prescribed by us from time to time to logon at the Internet Site to use the
Internet Banking Services and give Communication on your behalf to us on-line. We
are authorized to act on the Communication of each Authorized Internet User.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">8.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Any Communication must be sent by the Authorized
Internet Users to us at such website address and contact point as we may
specify from time to time. Unless otherwise expressly agreed by us, Authorized
Internet Users shall not send any Communication to our individual officers.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">8.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">A Communication shall not be considered to be
received by us unless it is given in such manner as we may prescribe from time
to time and until we have actually received it.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">8.4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Any Communication, once given, may not be
rescinded or withdrawn without our consent. We shall be under no duty to verify
the identity or authority of the person sending any Communication or the
authenticity of any Communication apart from verifying the User ID, the
Password, the Security Code and such other identifiers (if any) of the relevant
Authorized Internet User.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">8.5<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">We will only act on a Communication insofar as
it is in our opinion practicable and reasonable to do so and in accordance with
our regular business practices and procedures. </span><span lang="EN-US">We have
a right to delay acting or refuse to act on a Communication if we are aware of
or suspect a breach of security or other suspicious circumstances relating to
the use of Internet Banking Services.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">8.6<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">All transactions effected by us for you pursuant
to a Communication shall be binding on you.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">8.7<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Advice or Confirmation that a Communication has
been received by us and/or a transaction or dealing has been effected may be
provided by us on-line if you have so elected and agreed. You agree to check
such advice or Confirmation to ensure its accuracy and completeness. You will enquire
with us if you do not receive an advice or Confirmation or if you believe that
any information in such advice or Confirmation is inaccurate or incomplete.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">8.8<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Information relating to any account, transaction
or dealing made available on the Internet Site(s) are for reference only. Our
records of such account, transaction or dealing shall in absence of fraud or
manifest error be evidence thereof.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref122100967"></a><a name="_Ref121937301"><span lang="EN-US"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;</span>9<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Information Provider</span></a><span lang="EN-US">s</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">9.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">An Information Provider may impose from time to
time terms and conditions in relation to the availability of any Information
supplied by it. Access to such Information by you on or after the effective
date, subject to prior notification, of such terms and conditions shall
constitute your acceptance thereof.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">9.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">The Information and the Reports are made
available for reference only.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">9.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Except to the extent required by applicable Laws
or provided for in any Relevant Document, neither we nor any Information
Provider warrants, represents or guarantees the sequence, accuracy, truth,
reliability, adequacy, timeliness or completeness of any of the Information or
the Reports or whether it is fit for any purpose. You agree to independently
assess and verify such matters in any Information or Report and, except to the
extent required by applicable Laws or provided for in any Relevant Document,
neither we nor any Information Provider assumes any liability (whether in tort
or contract or otherwise) for any reliance on the Information or the Reports by
you or any other person. However, this clause does not preclude any
responsibility that we or the Information Provider may have to you or any other
person in relation to conduct, statements or representations that we or the
Information Provider may have under applicable
Laws. </span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">9.4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">The Information will be made available as it is
supplied by the Information Provider. We do not endorse or express any comment
on any Information supplied by any other Information Provider nor assume any
duty to check or verify any Information.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref122023787"><span lang="EN-US">10<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Confidential Information</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">10.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Confidential Information are trade secrets and
confidential and proprietary property of us and the respective Information
Providers.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">10.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Unless expressly permitted by these Internet
Banking Terms or us, you shall neither do nor attempt to do any of the
following:</span></p>

<p class="StandardL3"><span lang="EN-US">(A)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">sell, transfer, disclose, assign, convey, lease,
sub-license, share, loan, distribute, transmit, broadcast, cablecast, put in
circulation, duplicate or otherwise provide or disseminate any Confidential
Information in any form or by any means to any other person or commercially
exploit any Confidential Information;</span></p>

<p class="StandardL3"><span lang="EN-US">(B)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">download or reproduce any Confidential
Information other than for your own personal reference and use; and/or</span></p>

<p class="StandardL3"><span lang="EN-US">(C)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">remove, obliterate, erase, relocate or modify in
any way any proprietary marking on or appearing with the Confidential
Information including, without limitation, any trademark or copyright notice.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">10.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">The restrictions on disclosure shall not apply
to any Confidential Information:</span></p>

<p class="StandardL3"><span lang="EN-US">(A)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">where its disclosure is compelled by law but
only to the extent required by law and only after written notice of the
requirement to disclose has been given by you to us; or</span></p>

<p class="StandardL3"><span lang="EN-US">(B)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">where we have expressly agreed in writing to its
disclosure.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">10.4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">All right, title and interest in and relating to
the Confidential Information and any and all related copyright, patent,
trademark, service mark, proprietary property, trade secrets and exclusive
works are and shall remain the exclusive property of us and the respective
Information Providers. No right, title or interest other than the right to
access the Information and the Reports subject to these Internet Banking Terms
is conveyed or transferred to you. You shall not make any representation or do
any act which may be taken to indicate that you have any such right, title or
interest.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref121937309"><span lang="EN-US">11<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Liabilities of the Bank</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">11.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">We will take reasonably practicable steps to
ensure that our systems in connection with the Internet Banking Services are
installed with adequate security designs and to control and manage the risks in
operating the systems, taking into account any Laws, circulars, codes of
conduct and prevailing market practices which may be applicable to us from time
to time.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref156405341"><span lang="EN-US">11.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">None of us, any Group Office or any Information
Provider warrants or represents that the Internet Banking Services, the Information
and the Reports are free from viruses or other destructive features which may
adversely affect your hardware, software or equipment. </span></a><span lang="EN-US">&nbsp;</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref122086615"><span lang="EN-US">11.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Unless Clause </span></a><span lang="EN-US">12.2 below</span><span lang="EN-US"> applies or due to our fraud, negligence
or wilful default, or the fraud, negligence or wilful default of any Group
Office or our/their respective officers or employees, , neither we nor any
Group Office assumes any liability or responsibility to you or any other person
for the consequences arising from or in connection with:</span></p>

<p class="StandardL3"><span lang="EN-US">(A)<span style="font:8.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">the use of the Internet Banking Services and/or
access to any Information as a result of such use by you or any other person
whether or not authorized;</span></p>

<p class="StandardL3"><span lang="EN-US">(B)<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">any interruption, interception, suspension,
delay, loss, unavailability, mutilation or other failure in providing the
Internet Banking Services (including, without limitation, any interruption,
interception, suspension, delay or failure to generate the Security Code), in
transmitting Information or Communication relating to the Internet Banking
Services or in connecting with the Internet Site(s) caused by any acts,
omissions or circumstances beyond our reasonable control including, without
limitation, failure of any communication network, act or omission of any third
party service providers, mechanical failure, power failure, malfunction,
breakdown, or inadequacy of equipment, installation or facilities, or any Law,
codes, directions, regulatory guidelines or government order (whether or not
having the force of law); and</span></p>

<p class="StandardL3"><span lang="EN-US">(C)<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">transmission and/or storage of any information
and/or data relating to you and/or the Internet Banking Services through or in
any system, equipment or instrument of any communication network provider.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref122086651"><span lang="EN-US">11.4<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Neither we, any Group Office or any Information
Provider shall be liable to you or any other person for any incidental,
indirect, special, consequential or exemplary damages including, without
limitation, any loss of use, revenue, profits or savings.</span></a><span lang="EN-US"> This clause does not apply in circumstances of our/their fraud,
negligence or wilful default,</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><a name="_Ref121937316"><span lang="EN-US">12<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Liabilities of the Customer</span></a></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">12.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Unless Clause </span><span lang="EN-US">12.2 below</span><span lang="EN-US"> applies or unless there is fraud,
negligence or wilful default by us , you shall be fully liable and responsible
for all consequences arising from or in connection with the use of the Internet
Banking Services and/or access to any Information or Report or any other
information as a result of such use by you or any other person whether or not
authorized.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref121937367"><span lang="EN-US">12.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Subject to your obligations under Clause </span></a><span lang="EN-US">7</span><span lang="EN-US"> (<i>User ID and Password</i>) and if, in our
reasonable opinion, there is no gross negligence or fraud on your part, you
shall not be liable for loss or misplacement of funds caused by unauthorized
transactions conducted through the use of the Internet Banking Services.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><a name="_Ref122086622"><span lang="EN-US">12.3<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">You shall indemnify us, any Group Office, any
Information Provider and their respective officers and employees against all
liabilities, claims, demands, Losses, damages, costs, charges and expenses of
any kind (including, without limitation, legal costs on a full indemnity basis)
which may be reasonably and properly incurred by any of them and all actions or
proceedings which may be brought by or against any of them in connection with
the provision of the Internet Banking Services, the Information and/or the Reports
or the exercise or preservation of our powers and rights under these Internet
Banking Terms and the Standard Terms, unless due to our fraud, negligence or
wilful default, or the fraud, negligence or wilful default of any Group Office,
any Information Provider or our/their respective officers or employees or
unless Clause </span></a><span lang="EN-US">12.2 above</span><span lang="EN-US"> applies.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><span lang="EN-US">13<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Amendments</span></p>

<p class="StandardL2" style="text-indent:0cm"><span lang="EN-US">We may amend
and/or add to, these Internet Banking Terms from time to time in accordance with the Standard Terms. Any revision
and/or addition to the Internet Banking Terms shall become effective subject to
us giving prior reasonable notice which may be given to you by posting it on
the Internet Site(s) or by any other means as we think fit, and shall be
binding on you if you continue to maintain or use the Internet Banking Services
on or after the effective date of variation.</span></p>

<p class="StandardL1" style="text-indent:-1.0cm"><span lang="EN-US">14<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Form of Notice and Communication</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">14.1<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">We shall be entitled to prescribe, from time to
time, the form of notice (whether written or any other form) and the mode of
Communication with respect to each type of notice to be given pursuant to these
Internet Banking Terms.</span></p>

<p class="StandardL2" style="text-indent:-1.0cm"><span lang="EN-US">14.2<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang="EN-US">Communication sent by e-mail shall be deemed to
have been received by you immediately after transmitting to the e-mail address
last notified in writing by you to us.</span></p>
` + tc2;
